import { Dispatch, memo, SetStateAction, useRef } from 'react';
import clsx from 'clsx';

import { ChannelPreviewUIComponentProps } from 'stream-chat-react';
import PreviewButtons from './PreviewButtons';
import { LayoutStage } from './StreamChat';

type CustomChannelPreviewProps = ChannelPreviewUIComponentProps & {
  setActiveView?: Dispatch<SetStateAction<LayoutStage>>;
};

const UnMemoizedChannelPreviewMessenger = ({ ...props }: CustomChannelPreviewProps) => {
  const {
    active,
    channel,
    className: customClassName = '',
    displayTitle,
    latestMessagePreview,
    setActiveChannel,
    unread,
    watchers,
  } = props;

  const channelPreviewButton = useRef<HTMLButtonElement | null>(null);

  const onSelectChannel = () => {
    if (setActiveChannel) {
      setActiveChannel(channel, watchers);
    }
    if (channelPreviewButton?.current) {
      channelPreviewButton.current.blur();
    }
  };

  return (
    <div className="str-chat__channel-preview-container">
      <PreviewButtons channel={channel} />
      <button
        aria-label={`Select Channel: ${displayTitle || ''}`}
        aria-selected={active}
        className={clsx(
          `str-chat__channel-preview-messenger str-chat__channel-preview`,
          active && 'str-chat__channel-preview-messenger--active',
          unread && unread >= 1 && 'str-chat__channel-preview-messenger--unread',
          customClassName
        )}
        data-testid="channel-preview-button"
        onClick={onSelectChannel}
        ref={channelPreviewButton}
        role="option"
      >
        <div className="str-chat__channel-preview-end">
          <div className="str-chat__channel-preview-end-first-row">
            <div className="channel-preview-messenger--name">
              <span>{displayTitle}</span>
            </div>
            {!!unread && (
              <div className="str-chat__channel-preview-unread-badge" data-testid="unread-badge">
                {unread}
              </div>
            )}
          </div>
          <div className="str-chat__channel-preview-messenger--last-message">{latestMessagePreview}</div>
        </div>
      </button>
    </div>
  );
};

export const CustomChannelPreview = memo(UnMemoizedChannelPreviewMessenger);
